import React, { useEffect } from "react";
import Header from "components/Common/Header/Header";
import SaveCategoryBody from "components/AdministrationComponents/CategoryComponents/SaveCategory/SaveCategoryBody";

const SaveCategory = () => {
  useEffect(() => {
    document.title = "Administration | Categories";
  }, []);

  return (
    <main id="app">
      <Header moduleName="administration" />
      <SaveCategoryBody />
    </main>
  );
};

export default SaveCategory;
